import styled from 'styled-components/macro';

import SidemodalBase from '@components/common/core/DataDisplay/SideModal';

export const Sidemodal = styled(SidemodalBase)``;
